// Dynamic Google Fonts loader used by ThemeProvider.
//
// Rationale: shipping all 5 Google Font families via next/font adds ~374KB
// of @font-face CSS declarations to every public page, even though any one
// visitor only ever sees ONE theme's worth of fonts. This helper lets us
// keep only the default theme's fonts in the critical path and lazy-load
// secondary-theme fonts when the user actually switches themes.
//
// Fonts we still ship via next/font (kept in app/layout.js):
//   - Zen Maru Gothic (heading for themeA/B/C)
//   - Noto Sans TC    (body for all themes)
//
// Fonts we lazy-load here (injected into <head> when their theme activates):
//   - Caveat          (accent for themeA/B)
//   - Montserrat      (heading/body/accent for themeC)
//   - Playfair Display (heading/accent for themeD)
//
// Themes E-H don't need anything extra — they reference serif fonts that
// already fall back to system fonts on the user's device.
//
// The loader dedups via a Set so repeated theme toggles don't inject duplicate
// <link> tags. Fonts are fetched with display=swap so the browser shows the
// fallback immediately and swaps in the custom font when ready (no FOUT).

const injected = new Set();

export function ensureFontsLoaded(urls) {
  if (
    typeof document === "undefined" ||
    !Array.isArray(urls) ||
    urls.length === 0
  )
    return;
  for (const url of urls) {
    if (!url || injected.has(url)) continue;
    injected.add(url);
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    link.dataset.dynFont = "1";
    document.head.appendChild(link);
  }
}
